<div class="ar-wrapper">

  <!-- Page Header -->
  <div class="ar-page-header">
    <div class="ar-header-left">
      <span class="ar-eyebrow">Applicant Management</span>
      <h2 class="ar-title">Application Review</h2>
      <p class="ar-subtitle" *ngIf="!isLoading && !errorMessage">
        <strong>{{ allApplicants.length }}</strong> total applicant{{ allApplicants.length !== 1 ? 's' : '' }} in the registry
      </p>
    </div>
    <button class="ar-btn-refresh" (click)="loadData()" [disabled]="isLoading">
      <span class="refresh-icon" [class.spinning]="isLoading">↻</span>
      {{ isLoading ? 'Loading...' : 'Refresh' }}
    </button>
  </div>

  <!-- Stat Cards -->
  <div class="ar-stats-row" *ngIf="!errorMessage">
    <div class="ar-stat-card ar-stat-featured">
      <div class="ar-stat-icon">📋</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">Total Applicants</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statAll }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">All submissions</div>
      </div>
    </div>
    <div class="ar-stat-card">
      <div class="ar-stat-icon">⏳</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">Pending Review</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statPending }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">Awaiting decision</div>
      </div>
    </div>
    <div class="ar-stat-card">
      <div class="ar-stat-icon">🔍</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">Under Review</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statUnderReview }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">Being evaluated</div>
      </div>
    </div>
    <div class="ar-stat-card">
      <div class="ar-stat-icon">✅</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">Accepted</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statAccepted }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">Approved applications</div>
      </div>
    </div>
    <div class="ar-stat-card">
      <div class="ar-stat-icon">❌</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">Rejected</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statRejected }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">Declined applications</div>
      </div>
    </div>
    <div class="ar-stat-card">
      <div class="ar-stat-icon">🎓</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">SHS Graduates</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statSHS }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">WASSCE applicants</div>
      </div>
    </div>
    <div class="ar-stat-card">
      <div class="ar-stat-icon">📜</div>
      <div class="ar-stat-body">
        <div class="ar-stat-label">Diploma Holders</div>
        <div class="ar-stat-value">
          <span *ngIf="!isLoading">{{ statDiploma }}</span>
          <span *ngIf="isLoading" class="ar-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ar-stat-sub">Diploma applicants</div>
      </div>
    </div>
  </div>

  <!-- Toolbar -->
  <div class="ar-toolbar" *ngIf="!errorMessage">
    <div class="ar-search-wrap">
      <svg class="ar-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
      </svg>
      <input
        class="ar-search-input"
        type="text"
        placeholder="Search by name, email or programme…"
        [(ngModel)]="searchQuery"
        (input)="onSearch()" />
      <button class="ar-search-clear" *ngIf="searchQuery" (click)="searchQuery=''; onSearch()">✕</button>
    </div>
    <div class="ar-filter-group">
      <button class="ar-filter-btn" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">All</button>
      <button class="ar-filter-btn" [class.active]="activeFilter === 'Pending'" (click)="setFilter('Pending')">
        <span class="ar-dot dot-amber"></span> Pending
      </button>
      <button class="ar-filter-btn" [class.active]="activeFilter === 'Under Review'" (click)="setFilter('Under Review')">
        <span class="ar-dot dot-blue"></span> Under Review
      </button>
      <button class="ar-filter-btn" [class.active]="activeFilter === 'Accepted'" (click)="setFilter('Accepted')">
        <span class="ar-dot dot-green"></span> Accepted
      </button>
      <button class="ar-filter-btn" [class.active]="activeFilter === 'Rejected'" (click)="setFilter('Rejected')">
        <span class="ar-dot dot-red"></span> Rejected
      </button>
    </div>
  </div>

  <!-- Table Container -->
  <div class="ar-table-wrap">

    <!-- Loading Skeletons -->
    <div *ngIf="isLoading" class="ar-skeleton-wrap">
      <div class="ar-skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="ar-skeleton" style="width:24px"></div>
        <div style="display:flex;align-items:center;gap:10px">
          <div class="ar-skeleton" style="width:34px;height:34px;border-radius:50%;flex-shrink:0"></div>
          <div style="display:flex;flex-direction:column;gap:6px">
            <div class="ar-skeleton" style="width:130px"></div>
            <div class="ar-skeleton" style="width:160px;height:10px"></div>
          </div>
        </div>
        <div class="ar-skeleton" style="width:110px"></div>
        <div class="ar-skeleton" style="width:130px"></div>
        <div class="ar-skeleton" style="width:70px"></div>
        <div class="ar-skeleton" style="width:80px"></div>
        <div class="ar-skeleton" style="width:90px"></div>
        <div class="ar-skeleton" style="width:120px"></div>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && errorMessage" class="ar-state-box">
      <div class="ar-state-icon">⚠️</div>
      <div class="ar-state-title">Could not load data</div>
      <div class="ar-state-sub">{{ errorMessage }}</div>
      <button class="ar-btn-refresh" style="margin-top:16px" (click)="loadData()">Try Again</button>
    </div>

    <!-- Table -->
    <table *ngIf="!isLoading && !errorMessage">
      <thead>
        <tr>
          <th></th>
          <th>#</th>
          <th>Applicant</th>
          <th>Phone</th>
          <th>Programme</th>
          <th>Type</th>
          <th>Academic Year</th>
          <th>Status</th>
          <th>Applied On</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>

        <!-- Empty State -->
        <tr *ngIf="pagedApplicants.length === 0">
          <td colspan="10">
            <div class="ar-state-box">
              <div class="ar-state-icon">🔍</div>
              <div class="ar-state-title">No applicants found</div>
              <div class="ar-state-sub">Try adjusting your search or filter criteria</div>
            </div>
          </td>
        </tr>

        <ng-container *ngFor="let a of pagedApplicants; let i = index">

          <!-- Main Row -->
          <tr [class.row-expanded]="expandedRowId === a.applicantId" (click)="toggleRow(a.applicantId)" class="ar-data-row">
            <td class="td-chevron">
              <span class="chevron" [class.open]="expandedRowId === a.applicantId">›</span>
            </td>
            <td class="td-index">{{ pageStart + i }}</td>
            <td>
              <div class="ar-td-name">
                <div class="ar-avatar">
                  <img
                    *ngIf="hasPhoto(a)"
                    [src]="a.photoPath"
                    [alt]="getInitials(a)"
                    class="ar-avatar-img ar-avatar-clickable"
                    (click)="openLightbox(a.photoPath, a.firstName + ' ' + a.lastName, $event)"
                    (error)="onImgError(a.applicantId)" />
                  <span *ngIf="!hasPhoto(a)">{{ getInitials(a) }}</span>
                </div>
                <div>
                  <div class="ar-name">{{ a.firstName }} {{ a.lastName }}</div>
                  <div class="ar-email">{{ a.email }}</div>
                </div>
              </div>
            </td>
            <td class="td-muted">{{ a.phoneNumber || '—' }}</td>
            <td class="td-programme">{{ a.programmeAppliedFor || '—' }}</td>
            <td>
              <span class="ar-badge badge-type">{{ a.applicantType || '—' }}</span>
            </td>
            <td class="td-muted">{{ a.academicYear || '—' }}</td>
            <td>
              <span class="ar-badge" [ngClass]="getStatusClass(a.applicationStatus)">
                {{ getStatusLabel(a.applicationStatus) }}
              </span>
            </td>
            <td class="td-muted td-date">{{ formatDate(a.applicationDate) }}</td>
            <td class="td-actions" (click)="$event.stopPropagation()">
              <button
                class="ar-action-btn btn-under-review"
                [disabled]="a.applicationStatus === 'Under Review'"
                (click)="openModal(a, 'Under Review', $event)"
                title="Mark as Under Review">
                🔍 Review
              </button>
              <button
                class="ar-action-btn btn-accept"
                [disabled]="a.applicationStatus === 'Accepted'"
                (click)="openModal(a, 'Accepted', $event)"
                title="Accept Application">
                ✓ Accept
              </button>
              <button
                class="ar-action-btn btn-reject"
                [disabled]="a.applicationStatus === 'Rejected'"
                (click)="openModal(a, 'Rejected', $event)"
                title="Reject Application">
                ✕ Reject
              </button>
            </td>
          </tr>

          <!-- Expanded Detail Row -->
          <tr class="ar-detail-row" *ngIf="expandedRowId === a.applicantId">
            <td colspan="10">
              <div class="ar-detail-panel">

                <div class="ar-detail-grid">

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Applicant ID</div>
                    <div class="ar-detail-value">#{{ a.applicantId }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Gender</div>
                    <div class="ar-detail-value">{{ a.gender || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Date of Birth</div>
                    <div class="ar-detail-value">{{ formatDate(a.dateOfBirth) }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Nationality</div>
                    <div class="ar-detail-value">{{ a.nationality || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Alternate Phone</div>
                    <div class="ar-detail-value">{{ a.alternatePhone || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Study Mode</div>
                    <div class="ar-detail-value">{{ a.preferredStudyMode || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Programme Type</div>
                    <div class="ar-detail-value">{{ a.programmeType || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Semester</div>
                    <div class="ar-detail-value">{{ a.semester || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Previous School</div>
                    <div class="ar-detail-value">{{ a.previousSchool || '—' }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">WASSCE Index</div>
                    <div class="ar-detail-value">
                      <span class="ar-ref-code">{{ a.wassceIndexNumber || '—' }}</span>
                    </div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Review Date</div>
                    <div class="ar-detail-value">{{ formatDate(a.reviewDate) }}</div>
                  </div>

                  <div class="ar-detail-group">
                    <div class="ar-detail-label">Decision Date</div>
                    <div class="ar-detail-value">{{ formatDate(a.decisionDate) }}</div>
                  </div>

                  <div class="ar-detail-group ar-detail-wide" *ngIf="a.reviewerComments">
                    <div class="ar-detail-label">Reviewer Comments</div>
                    <div class="ar-detail-value ar-comments">{{ a.reviewerComments }}</div>
                  </div>

                </div>

                <!-- ── Documents Section ── -->
                <div class="ar-detail-docs" *ngIf="a.photoPath || a.birthCertificatePath || a.academicTranscriptsPath || a.recommendationLettersPath || a.personalStatementPath">
                  <div class="ar-detail-label" style="width:100%;margin-bottom:8px">Documents</div>
                  <a *ngIf="a.photoPath"
                     [href]="a.photoPath" target="_blank"
                     class="ar-doc-chip ar-doc-photo"
                     (click)="$event.stopPropagation()">
                    🖼 Passport Photo
                  </a>
                  <a *ngIf="a.birthCertificatePath"
                     [href]="a.birthCertificatePath" target="_blank"
                     class="ar-doc-chip ar-doc-pdf"
                     (click)="$event.stopPropagation()">
                    📄 Birth Certificate
                  </a>
                  <a *ngIf="a.academicTranscriptsPath"
                     [href]="a.academicTranscriptsPath" target="_blank"
                     class="ar-doc-chip ar-doc-pdf"
                     (click)="$event.stopPropagation()">
                    📋 Academic Transcripts
                  </a>
                  <a *ngIf="a.recommendationLettersPath"
                     [href]="a.recommendationLettersPath" target="_blank"
                     class="ar-doc-chip ar-doc-pdf"
                     (click)="$event.stopPropagation()">
                    ✉ Recommendation Letters
                  </a>
                  <a *ngIf="a.personalStatementPath"
                     [href]="a.personalStatementPath" target="_blank"
                     class="ar-doc-chip ar-doc-pdf"
                     (click)="$event.stopPropagation()">
                    📝 Personal Statement
                  </a>
                </div>

              </div>
            </td>
          </tr>

        </ng-container>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="ar-pagination" *ngIf="!isLoading && !errorMessage && filteredApplicants.length > 0">
      <span class="ar-page-info">
        Showing <strong>{{ pageStart }}–{{ pageEnd }}</strong> of <strong>{{ filteredApplicants.length }}</strong> applicants
        &nbsp;·&nbsp; <span style="color:#aaa">click a row to expand details</span>
      </span>
      <div class="ar-page-btns">
        <button class="ar-page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">&#8249;</button>
        <button
          *ngFor="let p of pages"
          class="ar-page-btn"
          [class.active]="p === currentPage"
          (click)="goToPage(p)">
          {{ p }}
        </button>
        <button class="ar-page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">&#8250;</button>
      </div>
    </div>

  </div>

  <!-- ── Confirm Modal ── -->
  <div class="ar-modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="ar-modal" (click)="$event.stopPropagation()">

      <div class="ar-modal-header" [ngClass]="modalAction === 'Accepted' ? 'modal-header-accept' : modalAction === 'Under Review' ? 'modal-header-review' : 'modal-header-reject'">
        <span class="ar-modal-icon">{{ modalAction === 'Accepted' ? '✅' : modalAction === 'Under Review' ? '🔍' : '❌' }}</span>
        <h3 class="ar-modal-title">{{ modalAction === 'Accepted' ? 'Accept Application' : modalAction === 'Under Review' ? 'Mark as Under Review' : 'Reject Application' }}</h3>
        <button class="ar-modal-close" (click)="closeModal()">✕</button>
      </div>

      <div class="ar-modal-body" *ngIf="modalApplicant">
        <div class="ar-modal-applicant">
          <div class="ar-avatar ar-avatar-lg">
            <img
              *ngIf="modalApplicant && hasPhoto(modalApplicant)"
              [src]="modalApplicant.photoPath"
              [alt]="getInitials(modalApplicant)"
              class="ar-avatar-img"
              (error)="onImgError(modalApplicant.applicantId)" />
            <span *ngIf="!modalApplicant || !hasPhoto(modalApplicant)">
              {{ modalApplicant ? getInitials(modalApplicant) : '' }}
            </span>
          </div>
          <div>
            <div class="ar-modal-name">{{ modalApplicant.firstName }} {{ modalApplicant.lastName }}</div>
            <div class="ar-modal-meta">{{ modalApplicant.programmeAppliedFor }} · {{ modalApplicant.applicantType }}</div>
          </div>
        </div>

        <div class="ar-modal-field">
          <label class="ar-modal-label">Reviewer Comments <span style="color:#aaa">(optional)</span></label>
          <textarea
            class="ar-modal-textarea"
            [(ngModel)]="reviewerComments"
            placeholder="Add comments about this decision…"
            rows="4">
          </textarea>
        </div>

        <div class="ar-modal-confirm-msg" [ngClass]="modalAction === 'Accepted' ? 'confirm-accept' : modalAction === 'Under Review' ? 'confirm-review' : 'confirm-reject'">
          You are about to mark this application as <strong>{{ modalAction === 'Accepted' ? 'ACCEPTED' : modalAction === 'Under Review' ? 'UNDER REVIEW' : 'REJECTED' }}</strong>.
          This action will be recorded with today's date.
        </div>

        <div class="ar-submit-success" *ngIf="submitSuccess">✓ {{ submitSuccess }}</div>
        <div class="ar-submit-error" *ngIf="submitError">⚠ {{ submitError }}</div>
      </div>

      <div class="ar-modal-footer">
        <button class="ar-modal-btn btn-cancel" (click)="closeModal()" [disabled]="isSubmitting">Cancel</button>
        <button
          class="ar-modal-btn"
          [ngClass]="modalAction === 'Accepted' ? 'btn-confirm-accept' : modalAction === 'Under Review' ? 'btn-confirm-review' : 'btn-confirm-reject'"
          (click)="confirmStatusUpdate()"
          [disabled]="isSubmitting">
          {{ isSubmitting ? 'Saving...' : (modalAction === 'Accepted' ? '✓ Confirm Accept' : modalAction === 'Under Review' ? '🔍 Confirm Review' : '✕ Confirm Reject') }}
        </button>
      </div>

    </div>
  </div>

  <!-- ── Photo Lightbox ── -->
  <div class="ar-lightbox-overlay" *ngIf="lightboxUrl" (click)="closeLightbox()">
    <div class="ar-lightbox" (click)="$event.stopPropagation()">
      <div class="ar-lightbox-header">
        <span class="ar-lightbox-name">{{ lightboxName }}</span>
        <div style="display:flex;gap:8px">
          <a [href]="lightboxUrl" target="_blank" class="ar-lightbox-btn" title="Open in new tab">↗ View Full</a>
          <a [href]="lightboxUrl" download class="ar-lightbox-btn" title="Download">⬇ Download</a>
          <button class="ar-lightbox-close" (click)="closeLightbox()">✕</button>
        </div>
      </div>
      <div class="ar-lightbox-body">
        <img [src]="lightboxUrl" [alt]="lightboxName" class="ar-lightbox-img" />
      </div>
    </div>
  </div>

</div>